import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import { ICenter } from "../../../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center/ICenter";

export const CentreMasterUpdateSlice = createSlice({
  name: "CentreMasterUpdateSlice",
  initialState: {} as IReduxState<ICenter>,
  reducers: {
    centreMasterUpdate: (state, _: PayloadAction<ICenter>) => {
      state.isLoading = true;
    },
    successCentreMasterUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterUpdate: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterUpdate,
  successCentreMasterUpdate,
  failureCentreMasterUpdate,
  clearCentreMasterUpdate,
} = CentreMasterUpdateSlice.actions;

export default CentreMasterUpdateSlice.reducer;
